module.exports = __webpack_public_path__ + "img/2.9526f7ee.png";